import CommentManagerDialog from "components/Editorial/ContentCommentManager/Dialog";
import Flash from "lib/flash";
import i18n from "lib/i18n";
import Minpubsub from "minpubsub";
import moment from "moment";
import PropTypes from "prop-types";
import React from "react";
import getSharedClassNameGenerator from "lib/shared_class_name_generator";
import { ajax as $ajax } from "jquery";
import { Button, ThemeProvider } from "@theconversation/ui";

const COMMENT_INFO_URL = "/editorial/content/:id/comments/schedule";

export default class ContentCommentManager extends React.Component {
  constructor(props) {
    super(props);

    this.changeCommentsCloseDate = this.changeCommentsCloseDate.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.openModal = this.openModal.bind(this);
    this.toggleCommentsClosed = this.toggleCommentsClosed.bind(this);

    this.state = {
      commentsClosed: false,
      commentsClosingAt: null,
      lastEditedDate: null,
      lastEditedUserName: null,
      modalIsOpen: false,
    };
  }

  closeModal() {
    this.setState({ modalIsOpen: false });
  }

  openModal() {
    const { contentId } = this.props;

    $ajax({
      url: COMMENT_INFO_URL.replace(":id", contentId),
      method: "GET",
      success: (data) => {
        const { comments, lastEdited } = data;

        this.setState({
          commentsClosed: comments.closed,
          commentsClosingAt: comments.closingAt,
          lastEditedDate: lastEdited.date,
          lastEditedUserName: lastEdited.userName,
          modalIsOpen: true,
        });
      },
      error: () => {
        Flash.now("alert", i18n.t("comment_manager.messages.loading_error"));
      },
    });
  }

  toggleCommentsClosed() {
    let { commentsClosed, commentsClosingAt } = this.state;

    commentsClosed = !commentsClosed;
    commentsClosingAt = commentsClosed ? moment().format() : null;

    this.setState({ commentsClosed, commentsClosingAt });
  }

  changeCommentsCloseDate(dateTime) {
    if (dateTime) {
      const now = moment();
      const commentsClosed = dateTime.isBefore(now);
      const commentsClosingAt = dateTime.format();

      this.setState({ commentsClosed, commentsClosingAt });
    } else {
      this.setState({ commentsClosed: false, commentsClosingAt: null });
    }
  }

  handleSubmit() {
    const { commentsClosed, commentsClosingAt } = this.state;
    const { contentId } = this.props;
    const minpubsubEvent = commentsClosed ? "comments:closed" : "comments:opened";

    $ajax({
      url: COMMENT_INFO_URL.replace(":id", contentId),
      method: "PUT",
      data: {
        closing_at: commentsClosingAt,
      },
      success: () => {
        Flash.now("notice", i18n.t("comment_manager.messages.updated"));
        Minpubsub.publish(minpubsubEvent, [commentsClosingAt]);

        this.setState({ modalIsOpen: false });
      },
      error: () => {
        Flash.now("alert", i18n.t("comment_manager.messages.loading_error"));
      },
    });
  }

  render() {
    return (
      <ThemeProvider generateClassName={getSharedClassNameGenerator()}>
        <Button onClick={this.openModal} colour="primary">{i18n.t("comment_manager.buttons.open_dialog")}</Button>
        <CommentManagerDialog
          changeCommentsCloseDate={this.changeCommentsCloseDate}
          handleSubmit={this.handleSubmit}
          onClose={this.closeModal}
          toggleCommentsClosed={this.toggleCommentsClosed}
          {...this.state}
        />
      </ThemeProvider>
    );
  }
}

ContentCommentManager.propTypes = {
  contentId: PropTypes.number.isRequired,
};

ContentCommentManager.defaultProps = {};

